<template>
  <div class="satisfactionPoll">
    <!-- <div class="satisfactionPoll" v-if="!chatRated && threadState == 'closed'"> -->
    <div class="poll" ref="content" aria-live="assertive">
      <div class="step_experience" v-show="this.stepVisible > 0">
        <div class="text-center">{{ $gettext('Encuesta de satisfacción')}}</div>
        <p class="text-center bold">{{ $gettext('¿Cómo valorarías la experiencia con nosotros?')}}</p>
        <div class="icon-wrapper">
          <div class="icon" v-for="(exp, key) in experiences" :key="key">
            <button tabindex="0" class="action-icon" name="experienceButton" :class="key" :aria-label="exp.translation"
              @keyup.enter="selectExperience(key)" @click="selectExperience(key)">
              <img :src="getStaticImage(key+'_filled.svg')" v-if="key == experience"></img>
              <img v-else :src="getStaticImage(key+'.svg')"></img>
            </button>
            <div class="checked">
              <div class="icon-checked" v-show="key == experience"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Se decidió por parte de negocio retirar este paso -->
      <!-- <div class="step_attention" v-show="this.stepVisible > 1">
        <p tabindex="0">{{ $gettext('¿Cómo calificarías la atención recibida por el agente?')}} <i>{{ $gettext('(Siendo el 1 una atención pobre y el 5 una atención excelente)')}}</i></p>
        <div class="radios-wrapper">
          <div class="radio" v-for="att in [1, 2, 3, 4, 5]" :key="att" tabindex="0" @keyup.enter="rateSelected(att)">
            <input 
                type="radio" 
                name="attention" 
                :id="'attention_' + att" 
                :value="att" 
                :checked="att === rate" 
                @keyup.enter="rateSelected(att)" 
                @click="rateSelected(att)">
            <label :for="'attention_' + att">{{ att }}</label>
          </div>
        </div>
      </div> -->
      <div class="step_resolved" v-show="this.stepVisible > 1">
        <p tabindex="0" class="text-center bold">{{ $gettext('¿Hemos podido resolver tu consulta?')}}</p>
        <div class="hands-wrapper">
          <div class="hands-icon" v-for="(resolved) in [true, false]" :key="resolved" :class="{'hand-left': resolved === true}">
            <div class="hands" tabindex="0" @keyup.enter="selectResolved(resolved)" @click="selectResolved(resolved)">
              <div class="marginRight" v-if="resolved === true">{{ $gettext('Sí')}}</div>
              <button v-if="resolved === true" class="action-icon">
                <svg xmlns="http://www.w3.org/2000/svg" id="happy_bold_24" width="24" height="24" viewBox="0 0 32 32">
                  <path id="happy_bold_24-2" data-name="happy_bold_24"
                    d="M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm0,28.8A12.8,12.8,0,1,1,30.8,18,12.8,12.8,0,0,1,18,30.8ZM13.75,13.475A1.325,1.325,0,1,1,15.075,14.8,1.325,1.325,0,0,1,13.75,13.475Zm5.85,0A1.325,1.325,0,1,1,20.925,14.8,1.325,1.325,0,0,1,19.6,13.475ZM27.085,21.9a10.085,10.085,0,0,1-18.17,0L11.8,20.5a6.886,6.886,0,0,0,12.406,0Z"
                    transform="translate(-2 -2)" fill="#427AB3" />
                </svg>
                <!--<img v-if="solved === true" :src="getStaticImage('Like_filled.svg')" alt="">
                <img v-else :src="getStaticImage('Like.svg')" alt="">-->
              </button>
              <button v-else class="action-icon">
                <svg xmlns="http://www.w3.org/2000/svg" id="sad_bold_24" width="24" height="24" viewBox="0 0 32 32">
                  <path id="sad_bold_24-2" data-name="sad_bold_24"
                    d="M27.085,25.3,24.2,26.7a6.886,6.886,0,0,0-12.406,0L8.917,25.3a10.085,10.085,0,0,1,18.168,0ZM34,18A16,16,0,1,1,18,2,16,16,0,0,1,34,18Zm-3.2,0A12.8,12.8,0,1,0,18,30.8,12.8,12.8,0,0,0,30.8,18ZM15.075,14.8a1.325,1.325,0,1,0-1.325-1.325A1.325,1.325,0,0,0,15.075,14.8Zm5.85,0A1.325,1.325,0,1,0,19.6,13.475,1.325,1.325,0,0,0,20.925,14.8Z"
                    transform="translate(-2 -2)" fill="#427AB3" />
                </svg>
              </button>
              <div class="marginLeft" v-if="resolved === false">{{ $gettext('No')}}</div>
            </div>
            <div class="checked">
              <div class="icon-checked" v-show="resolved === solved"></div>
            </div>
          </div>
        </div>
        <p class="text-center">{{ $gettext('Muchas gracias por tu respuesta') }}</p>
      </div>
      <div class="step_suggestions" tabindex="0" v-show="this.stepVisible > 2">
        <div class="value-experience">
          <svg xmlns="http://www.w3.org/2000/svg" id="happy_bold_24" width="40" height="40" viewBox="0 0 32 32">
            <path id="happy_bold_24-2" data-name="happy_bold_24"
              d="M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm0,28.8A12.8,12.8,0,1,1,30.8,18,12.8,12.8,0,0,1,18,30.8ZM13.75,13.475A1.325,1.325,0,1,1,15.075,14.8,1.325,1.325,0,0,1,13.75,13.475Zm5.85,0A1.325,1.325,0,1,1,20.925,14.8,1.325,1.325,0,0,1,19.6,13.475ZM27.085,21.9a10.085,10.085,0,0,1-18.17,0L11.8,20.5a6.886,6.886,0,0,0,12.406,0Z"
              transform="translate(-2 -2)" fill="#000" />
          </svg>
          <div class="experience-text">
            <p class="bold">{{ $gettext('Tu opinión nos importa') }}</p>
            <p>{{ $gettext('Cuéntanos tu experiencia con nosotros y seguiremos trabajando para ofrecerte el mejor servicio.') }}
              <!-- <a :href="pulseCXLang()" target="_blank" style="color: #000;">{{ $gettext('Encuesta de satisfacción del cliente') }}</a>. -->
            </p>
          </div>
        </div>
        <a :href="pulseCXLang()" target="_blank">
          <button class="button-opinion bold text-center" @click="saveRate(false)">
            <div class="icon-message"></div>
            {{ $gettext('Ayúdanos a mejorar')}}
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import { EventBus } from '@/event-bus';

export default {
  name: "SatisfactionPoll",
  data(){
    return{
      stepVisible: 1,
      experiences: {
        "sad": {translation: this.$gettext("triste")},
        "dissatisfied": {translation: this.$gettext("insatisfecho")},
        "neutral": {translation: this.$gettext("neutral")},
        "satisfied": {translation: this.$gettext("satisfecho")},
        "happy": {translation: this.$gettext("feliz")}
      },
      rate: null,
      solved: null,
      experience: null,
      comment: "",
    }
  },
  computed:{
    ...mapGetters(["chatRated", "threadState", "pulseCXUrl"]),
    ...mapState(["language"]),

  },
  mounted() {
    EventBus.$emit('satisfactionPollShown');
  },
  methods: {
    ...mapActions(['rateChat', 'closeCurrentChat']),
    pulseCXLang(){
      return `${this.pulseCXUrl}?sg_maintain_session=1&sg_navigate=start&sglocale=${this.language}`;
    },
    selectExperience(value){
      this.experience = value;
      this.showStep(2)
    },
    rateSelected(rate){
      this.rate = rate;
      this.showStep(3);
    },
    selectResolved(is_solved){
      this.solved = is_solved;
      this.showStep(4)
    },
    showStep(number){
        this.stepVisible = number;
        // partially save
        this.saveRate(true);
        this.$nextTick(()=>{
            EventBus.$emit('satisfactionPollShown'); // Change this line
        });
    },
    saveRate(partial){
      var data = {
        comment: this.comment,
        experience: this.experience,
        solved: this.solved,
        rate: this.rate
      }
      this.rateChat({data: data, partial_save: partial});
      if (!partial)
        this.closeCurrentChat(true)
    },
    getStaticImage(image){
      return process.env.VUE_APP_ASSETS_ROUTE+image+"?v="+process.env.VUE_APP_ASSETS_CACHE_VERSION;
    }
  }
}
</script>